export interface UpdateCorporatePositionDto {
  title: string; // Required, max 200
  description?: string | null; // Max 1000
  department?: string | null; // Max 100
  level?: number; // Range 1-10
  isActive?: boolean;
  isDefault?: boolean;
}
